<script setup lang="ts">
import type { NoneServiceModel } from '@/types'

defineProps<{
  modelValue: NoneServiceModel
}>()

defineEmits<{
  'update:modelValue': [value: NoneServiceModel]
}>()
</script>

<template>
  <div class="text-center py-5">
    <div class="mb-3">
      <i class="bi bi-question-circle display-4 text-muted"></i>
    </div>
    <h6 class="text-muted">No Service Configuration</h6>
    <p class="text-muted small mb-0">
      This service does not have a specific configuration type.<br />
      Please select a service type from the service library.
    </p>
  </div>
</template>

<style scoped lang="scss">
</style>